<mat-card class="default has-progress-bar" fxFlex="grow">
  <mat-progress-bar [mode]="(data.progress$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title fxLayoutAlign="space-between center">
    <span *ngIf="appointment?.startAt?.isValid(); else orderTitle">
      {{ 'patient-details.appointment.title' | translate }}
    </span>
    <ng-template #orderTitle>
      <span>
        {{ 'patient-details.appointment.order-title' | translate }}
      </span>
    </ng-template>
  </mat-card-title>
  <mat-card-content>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="appointment"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1em">
        <span *ngIf="facility" [matTooltip]="facility.name">
          {{ facility.abbreviation }}
        </span>
      </div>
    </div>

    <ng-container *ngIf="appointment?.orderingPhysician">
      <header class="subheading text-primary uppercase text-xs">
        {{ 'patient-details.appointment.order-physician' | translate }}
      </header>
      <div>
        {{ appointment.orderingPhysician.toUpperCase() }}
      </div>
    </ng-container>
    <header class="subheading text-primary uppercase text-xs">
      {{ 'patient-details.appointment.scheduling-details' | translate }}
    </header>
    <div fxLayout="column">
      <mmx-appointment-fact
        *ngIf="appointment?.duration != null"
        title="patient-details.appointment.duration"
      >
        {{ appointment?.duration }} {{ 'common.minutes' | translate }}
      </mmx-appointment-fact>

      <ng-container *ngIf="appointment?.resources">
        <ng-container *ngFor="let resourceType of resourceTypes">
          <mmx-appointment-fact
            *ngIf="getResourcesByType(resourceType).length > 0"
            [title]="resourceType"
          >
            <ng-container
              *ngFor="let resource of getResourcesByType(resourceType)"
            >
              <div>{{ resource.name }}</div>
            </ng-container>
          </mmx-appointment-fact>
        </ng-container>
      </ng-container>

      <mmx-appointment-fact
        *ngIf="appointment?.scheduledAt"
        title="patient-details.appointment.metadata-info.scheduled-at"
      >
        {{ appointment.scheduledAt | momentDateTime: appointment.timezone }}
      </mmx-appointment-fact>
    </div>

    <ng-container *ngIf="appointment?.notes">
      <header class="subheading text-primary uppercase text-xs">
        {{ 'patient-details.appointment.notes' | translate }}
      </header>
      <div [innerHTML]="appointment.notesHTML"></div>
    </ng-container>

    <ng-container *ngIf="customFields.appointmentFields$ | async as fields">
      <ng-container *ngIf="fields.length > 0">
        <header class="subheading text-primary uppercase text-xs">
          {{ 'patient-details.appointment.custom-fields' | translate }}
        </header>
        <mmx-appointment-fact *ngFor="let field of fields" [title]="field.name">
          <ng-container
            *ngIf="
              appointment &&
                appointment.customFields &&
                appointment.customFields[field.key] as value;
              else notSet
            "
          >
            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'Boolean'">
                {{ value ? 'True' : 'False' }}
              </div>
              <div *ngSwitchCase="'Date'">{{ value | momentDate }}</div>
              <div *ngSwitchCase="'DateTime'">{{ value | momentDateTime }}</div>
              <div *ngSwitchDefault>{{ value | join }}</div>
            </ng-container>
          </ng-container>
          <ng-template #notSet>{{ '[Not set]' }}</ng-template>
        </mmx-appointment-fact>
      </ng-container>
    </ng-container>

    <ng-container>
      <header
        class="subheading text-primary uppercase text-xs"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <span>{{ 'patient-details.appointment.metadata' | translate }}</span>
        <mat-icon (click)="showMetadata = !showMetadata">{{
          showMetadata ? 'expand_more' : 'expand_less'
        }}</mat-icon>
      </header>
      <div *ngIf="showMetadata">
        <mmx-appointment-fact
          *ngIf="appointment?.eid"
          title="patient-details.appointment.metadata-info.appointment-eid"
        >
          {{ appointment.eid }}
        </mmx-appointment-fact>
        <mmx-appointment-fact
          *ngIf="appointment?.ekey"
          title="patient-details.appointment.metadata-info.appointment-ekey"
        >
          {{ appointment.ekey }}
        </mmx-appointment-fact>
        <mmx-appointment-fact
          *ngIf="patient?.ekey"
          title="patient-details.appointment.metadata-info.patient-ekey"
        >
          {{ patient.ekey }}
        </mmx-appointment-fact>
        <mmx-appointment-fact
          *ngIf="appointment?.createdAt"
          title="patient-details.appointment.metadata-info.created-at"
        >
          {{ appointment.createdAt | momentDateTime: appointment.timezone }}
        </mmx-appointment-fact>
        <mmx-appointment-fact
          *ngIf="appointment?.updatedAt"
          title="patient-details.appointment.metadata-info.last-updated-at"
        >
          {{ appointment.updatedAt | momentDateTime: appointment.timezone }}
        </mmx-appointment-fact>
        <mmx-appointment-fact
          *ngFor="let metaField of keys(appointment.metadata).sort()"
          [title]="metaField"
        >
          <ng-container
            *ngIf="isString(appointment.metadata[metaField]); else jsonMetaData"
          >
            {{ appointment.metadata[metaField] }}
          </ng-container>
          <ng-template #jsonMetaData>
            {{ appointment.metadata[metaField] | json }}
          </ng-template>
        </mmx-appointment-fact>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
